export default __webpack_public_path__ + "static/media/loginBC.febba725.png";